/*
Stain Concentrates, Dye Stains, Dispersions
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Stain Concentrates / Dye Stains / Dispersions'
const id = 'KT00ewKGBzoMBpYxHRAz'

export default {
  name,
  id,
  filters,
  headers,
  form
}
